import axios from 'axios';
import _ from 'lodash';

function pickErrorMessage(error) {
    let errorMessage = '';
    if (error.response.data.errors[0].messages[0].message) {
        errorMessage = error.response.data.errors[0].messages[0].message;
    } else if (error.response.data.errors[0].messages[0]) {
        errorMessage = error.response.data.errors[0].messages[0];
    }
    return errorMessage;
}

/**
 * @deprecated use findPortAdmin for admin panel
 */
export function findPort({
    name,
    withAreas = false,
    onlyAreas = false,
    country = '',
    onlyAreasWithChild = false,
    withAreasWithChild = false,
    mainRegions = false,
    isInBalticIndex = false,
}) {
    return axios({
        method: 'POST',
        url: '/api/v1/ports/find',
        data: {
            name,
            withAreas,
            onlyAreas,
            country,
            onlyAreasWithChild,
            withAreasWithChild,
            mainRegions,
            isInBalticIndex,
        },
        withCredentials: true,
    });
}

export function findPortAdmin({
    name,
    withAreas = false,
    onlyAreas = false,
    country = '',
    onlyAreasWithChild = false,
    withAreasWithChild = false,
    mainRegions = false,
    isInBalticIndex = false,
    withUserPorts = false,
    skipSubPortsTreeGenerate = false,
}) {
    return axios({
        method: 'POST',
        url: '/api/v2/adminPanel/ports/find',
        data: {
            name,
            withAreas,
            onlyAreas,
            country,
            onlyAreasWithChild,
            withAreasWithChild,
            mainRegions,
            isInBalticIndex,
            withUserPorts,
            skipSubPortsTreeGenerate,
        },
        withCredentials: true,
    });
}

export function getAllPorts() {
    return axios({
        method: 'GET',
        url: '/api/v1/ports/allPorts',
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.data);
}

export function getPorts({
    page = 1, limit = 25, sort = 'name', onlyChanged = false, query = '',
    hasRecommended = undefined,
    expiredRecommended = undefined,
}) {
    const queryParams = new URLSearchParams();
    queryParams.append('page', page);
    queryParams.append('limit', limit);
    queryParams.append('sort', sort);
    queryParams.append('onlyChanged', onlyChanged);
    queryParams.append('query', query);

    if (hasRecommended !== undefined) {
        queryParams.append('hasRecommended', hasRecommended);
    }
    if (expiredRecommended !== undefined) {
        queryParams.append('expiredRecommended', expiredRecommended);
    }

    return axios({
        method: 'GET',
        url: `/api/v1/ports?${queryParams.toString()}`,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.data);
}

export function getAllPortsWithAltNames() {
    return axios({
        method: 'GET',
        url: '/api/v1/ports/all',
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.data);
}

export function getAllPortsWithCountryNames() {
    return axios({
        method: 'GET',
        url: '/api/v1/ports/names',
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.data);
}

export function updatePort(data) {
    // had to do that here, as redux-form reinitialises form values after normalize for http req
    const _data = _.cloneDeep(data);
    _data.serviceProviders = _data.serviceProviders.map((s) => {
        if (s.companyId && typeof s.companyId !== 'string' && s.companyId._id) {
            s.companyId = s.companyId._id;
        } else {
            s.companyId = undefined;
        }

        if (s.contactPersonId && typeof s.contactPersonId !== 'string' && s.contactPersonId._id) {
            s.contactPersonId = s.contactPersonId._id;
        } else {
            s.contactPersonId = undefined;
        }

        if (!s.recommended || !s.recommended.endAt) {
            delete s.recommended;
        }

        return s;
    });
    return axios({
        method: 'PUT',
        url: `/api/v1/ports/${_data._id}`,
        data: _data,
        withCredentials: true,
    })
        .then(response =>
            response.data)
        .catch(response =>
            response.response.data);
}

export function updatePortAlt(item) {
    return axios({
        method: 'PUT',
        url: `/api/v1/ports/${item._id}/alt`,
        data: {
            alt: item.alt,
        },
        withCredentials: true,
    })
        .then(response => ({
            ...response.data,
            item,
        }))// todo sending response.response
        .catch(response => ({
            ...response.response.data,
            item,
        }));
}

export function addNewPort(data) {
    return axios({
        method: 'post',
        url: '/api/v1/ports/',
        data,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

/**
 * get port
 * @param {{
 *  id: string,
 *  all?: boolean,
 *  history?: boolean,
 * }} data 
 */
export function getPort(data) {
    const all = data.all ? data.all : false;
    const url = data.history ? `/api/v1/ports/${data.id}/history?all=${all}` : `/api/v1/ports/${data.id}`;

    return axios({
        method: 'get',
        url,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response);
}

export function checkAndCreateRegion(name) {
    return axios({
        method: 'post',
        url: '/api/v1/ports/areas/check',
        withCredentials: true,
        data: {
            name,
        },
    });
}

export function mergeAreaOrPortToPort(portId, mergePortId) {
    return axios({
        method: 'put',
        url: `/api/v1/ports/${portId}/merge`,
        withCredentials: true,
        data: {
            mergeId: mergePortId,
        },
    });
}

/**
 * reject port modifications
 * @param {{
 *  _id: string,
 *  historyId: string,
 *  updateAt: number,
 * }} data 
 */
export function rejectPortModifications(data) {
    return axios({
        method: 'put',
        url: `/api/v1/ports/${data._id}/reject`,
        withCredentials: true,
        data: {
            _id: data.historyId,
            lastUpdate: data.updateAt,
        },
    })
        .then(response => response.data)
        .catch((error) => {
            throw pickErrorMessage(error);
        });
}

/**
 * approve port modifications
 * @param {{
 *  _id: string,
 *  historyId: string,
 *  updateAt: number,
 * }} data 
 * @returns 
 */
export function approvePortModifications(data) {
    return axios({
        method: 'put',
        url: `/api/v1/ports/${data._id}/approve`,
        withCredentials: true,
        data: {
            _id: data.historyId,
            lastUpdate: data.updateAt,
        },
    })
        .then(response => response.data)
        .catch((error) => {
            throw pickErrorMessage(error);
        });
}

/**
 * approve one port field
 * @param {{
 *  _id: string,
 *  historyId: string,
 *  fields: string[],
 *  updateAt: number,
 * }} data 
 */
export function approvePortModificationField(data) {
    return axios({
        method: 'put',
        url: `/api/v1/ports/${data._id}/approveFields`,
        withCredentials: true,
        data: {
            _id: data.historyId,
            lastUpdate: data.updateAt,
            fields: data.fields,
        },
    })
        .then(response => response.data)
        .catch((error) => {
            throw pickErrorMessage(error);
        });
}

/**
 * reject one port field
 * @param {{
 *  _id: string,
 *  historyId: string,
 *  fields: string[],
 *  updateAt: number,
 * }} data 
 */
export function rejectPortModificationField(data) {
    return axios({
        method: 'put',
        url: `/api/v1/ports/${data._id}/rejectFields`,
        withCredentials: true,
        data: {
            _id: data.historyId,
            lastUpdate: data.updateAt,
            fields: data.fields,
        },
    })
        .then(response => response.data)
        .catch((error) => {
            throw pickErrorMessage(error);
        });
}

/**
 * update one port field
 * @param {{
 *  _id: string,
 *  historyId: string,
 *  updateAt: number,
 *  toUpdate: Record<string, any>,
 * }} data 
 */
export function updatePortModificationField(data) {
    return axios({
        method: 'put',
        url: `/api/v1/ports/${data._id}/updateField`,
        withCredentials: true,
        data: {
            _id: data.historyId,
            lastUpdate: data.updateAt,
            toUpdate: data.toUpdate,
        },
    })
        .then(response => response.data)
        .catch((error) => {
            throw pickErrorMessage(error);
        });
}



// WEBPACK FOOTER //
// ./app/services/regions/ports.js